export const GET_COMPANY_LOGISTICS_ISSUES_REQUEST =
  "GET_COMPANY_LOGISTICS_ISSUES_REQUEST";
export const GET_COMPANY_LOGISTICS_ISSUES_RESPONSE =
  "GET_COMPANY_LOGISTICS_ISSUES_RESPONSE";

export const CREATE_COMPANY_LOGISTICS_ISSUE_REQUEST =
  "CREATE_COMPANY_LOGISTICS_ISSUE_REQUEST";
export const CREATE_COMPANY_LOGISTICS_ISSUE_RESPONSE =
  "CREATE_COMPANY_LOGISTICS_ISSUE_RESPONSE";

export const GET_COMPANY_LOGISTICS_ISSUE_DETAIL_REQUEST =
  "GET_COMPANY_LOGISTICS_ISSUE_DETAIL_REQUEST";
export const GET_COMPANY_LOGISTICS_ISSUE_DETAIL_RESPONSE =
  "GET_COMPANY_LOGISTICS_ISSUE_DETAIL_RESPONSE";

export const UPDATE_COMPANY_LOGISTICS_ISSUE_REQUEST =
  "UPDATE_COMPANY_LOGISTICS_ISSUE_REQUEST";
export const UPDATE_COMPANY_LOGISTICS_ISSUE_RESPONSE =
  "UPDATE_COMPANY_LOGISTICS_ISSUE_RESPONSE";

export const GET_COMPANY_LOGISTICS_ISSUE_COMMENTS_REQUEST =
  "GET_COMPANY_LOGISTICS_ISSUE_COMMENTS_REQUEST";
export const GET_COMPANY_LOGISTICS_ISSUE_COMMENTS_RESPONSE =
  "GET_COMPANY_LOGISTICS_ISSUE_COMMENTS_RESPONSE";

export const CREATE_COMPANY_LOGISTICS_ISSUE_COMMENT_REQUEST =
  "CREATE_COMPANY_LOGISTICS_ISSUE_COMMENT_REQUEST";
export const CREATE_COMPANY_LOGISTICS_ISSUE_COMMENT_RESPONSE =
  "CREATE_COMPANY_LOGISTICS_ISSUE_COMMENT_RESPONSE";

export const EXPORT_COMPANY_LOGISTICS_ISSUES_REQUEST =
  "EXPORT_COMPANY_LOGISTICS_ISSUES_REQUEST";
